import { createInjectionKey as t } from "./ghl-ui.es896.js";
const n = t("n-tabs");
export {
  n as tabsInjectionKey
};
